var base = require('settings/subscription/cancel-subscription');

Vue.component('spark-cancel-subscription', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/subscription/cancel-subscription.js